import { ScanSearch, MessagesSquare, BadgeCheck, Users, Wallet } from "lucide-react";
import { Reveal } from "./Reveal";
import { WHY_US } from "../config/business";

const ICONS = [ScanSearch, MessagesSquare, BadgeCheck, Users, Wallet];

export const WhyUs = () => (
  <section id="why-us" className="bg-[#0b0c0e] py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal className="text-center">
        <p className="font-display text-xs font-bold uppercase tracking-[0.3em] text-[#00AEEF] sm:text-sm">
          Why Choose Us
        </p>
        <h2 className="font-display mx-auto mt-3 max-w-3xl text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-[#f4f4f2] sm:text-4xl lg:text-5xl">
          Why Drivers Trust Auto Trust Centre
        </h2>
      </Reveal>

      <div className="mt-16 grid gap-10 sm:grid-cols-2 lg:grid-cols-5 lg:gap-7">
        {WHY_US.map((item, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={item.title} delay={i * 0.07} className="h-full">
              <div className="flex h-full flex-col border-t-2 border-[#00AEEF]/70 pt-6">
                <Icon className="h-8 w-8 text-[#00AEEF]" strokeWidth={1.7} />
                <h3 className="font-display mt-4 text-base font-bold uppercase leading-snug tracking-wide text-[#f4f4f2]">
                  {item.title}
                </h3>
                <p className="mt-2.5 text-sm leading-relaxed text-[#a6a9b1]">
                  {item.text}
                </p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
